import * as React from "react";
import { SVGProps, memo } from "react";

const SvgMedicineReadyMail = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.75 31.875a1.5 1.5 0 0 1 1.5-1.5H47.5a1.5 1.5 0 0 1 1.5 1.5v16.5a1.5 1.5 0 0 1-1.5 1.5H21.25a1.5 1.5 0 0 1-1.5-1.5v-16.5Z"
      fill="#ECF9F2"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.188 31.875c0-1.14.923-2.063 2.062-2.063H47.5c1.14 0 2.063.924 2.063 2.063v16.5c0 1.14-.924 2.063-2.063 2.063H21.25a2.062 2.062 0 0 1-2.063-2.063v-16.5Zm2.062-.938a.937.937 0 0 0-.938.938v16.5c0 .518.42.938.938.938H47.5c.518 0 .938-.42.938-.938v-16.5a.937.937 0 0 0-.938-.938H21.25Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.157 43.339 20.024 31.632l.718-.866 13.772 11.408 13.668-11.407.721.864-14.027 11.707a.563.563 0 0 1-.72.001Z"
      fill="#194D33"
    />

    <path d="M53.5 32.625a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z" fill="#4DB27F" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.625 32.625a5.625 5.625 0 1 1-11.25 0 5.625 5.625 0 0 1 11.25 0ZM49 37.125a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
      fill="#194D33"
    />

    <path
      d="M48.038 31.211c.13 0 .258-.01.382-.032.123-.022.234-.059.333-.11a.818.818 0 0 0 .256-.196.59.59 0 0 0 .142-.295h.508v3.82h-.683v-2.696h-.938v-.49Z"
      fill="#fff"
    />

    <path
      d="M17.48 26.296h-.235a7.832 7.832 0 0 1-5.286-2.288 7.81 7.81 0 0 1 2.532-12.744 7.81 7.81 0 0 1 10.208 10.208v.002a7.778 7.778 0 0 1-2.876 3.505 7.822 7.822 0 0 1-4.343 1.317Z"
      fill="#ECF9F2"
      stroke="#194D33"
      strokeWidth={1.4}
    />

    <path
      d="M17 14.5V19h3.5"
      stroke="#194D33"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Memo = memo(SvgMedicineReadyMail);

export default Memo;
